import api from '@/client/axiosInstance';
import { AdminRoute } from '@/constants';

export interface EmailMgmtUserRow {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  mailgunSync: boolean;
}

export interface EmailMgmtFranchiseRow {
  id: string;
  company: string;
  mailgunSync: boolean;
  users: EmailMgmtUserRow[];
}

export const getEmailMgmtConsultants = async (params: {
  search?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await api.get<{
    total: number;
    page: number;
    limit: number;
    users: EmailMgmtUserRow[];
  }>(AdminRoute.emailMgmtConsultants, { params });
  return response.data;
};

export const getEmailMgmtFranchisors = async (params: {
  search?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await api.get<{
    total: number;
    page: number;
    limit: number;
    franchises: EmailMgmtFranchiseRow[];
  }>(AdminRoute.emailMgmtFranchisors, { params });
  return response.data;
};

export const updateEmailMgmtUserSync = async (
  id: string,
  mailgunSync: boolean,
) => {
  const response = await api.patch(AdminRoute.emailMgmtUserSync(id), {
    mailgunSync,
  });
  return response.data as { id: string; mailgunSync: boolean };
};

export const updateEmailMgmtBrandSync = async (
  id: string,
  mailgunSync: boolean,
) => {
  const response = await api.patch(AdminRoute.emailMgmtBrandSync(id), {
    mailgunSync,
  });
  return response.data as { id: string; mailgunSync: boolean };
};

export const downloadEmailMgmtConsultants = async (params: {
  search?: string;
}) => {
  const response = await api.get(AdminRoute.emailMgmtConsultantsDownload, {
    params,
  });
  return response.data as { file: string };
};

export const downloadEmailMgmtFranchisors = async (params: {
  search?: string;
}) => {
  const response = await api.get(AdminRoute.emailMgmtFranchisorsDownload, {
    params,
  });
  return response.data as { file: string };
};
